module.exports = __webpack_public_path__ + "assets/week_chevron_right.69c2597c.svg";